import React, { Component } from "react";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import StepHeader from "./StepHeader";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

class TaskSelector extends Component {
	constructor(props) {
		super(props);
		this.handlecheckbox = this.handlecheckbox.bind(this);
	}
	
	handlecheckbox(e){
		//console.log('handlecheckbox ['+e.target.value+'] ]: '+e.target.checked);
		this.props.updateTask(e.target.value, e.target.checked);
	}
	
	render() {
		console.log(this.props);
		const { t } = this.props;
		let products = [];
		let productDesc;
		
		let AlertTooltip = withStyles((theme) => ({
			tooltip: {
				backgroundColor: 'rgba(153, 38, 34, 1)',
				boxShadow: theme.shadows[1],
				fontSize: 18,
			},
		}))(Tooltip);
	
	
		this.props.product.forEach((product) => {
//			var sufix="";
//			if(product.langPair!==null){
//				sufix=" "+product.langPair.code;
//			}
			if(product=="proof_print"){
				productDesc=<span>{this.props.t(product)}<span style={{fontFamily: "'Times New Roman', Times, serif", fontSize: "18px", fontWeight: "bold", color: "#3b9646"}}> G </span></span>
			}else{
				productDesc=this.props.t(product);
			}
			if(product==="proof_print" && this.props.extension!=="pdf"){
				let tooltip = this.props.t('galerada_pdf');
				products.push(<Grid item  xs={12}><AlertTooltip title={tooltip} placement="right"><FormControlLabel
					control={
						<Checkbox
							defaultChecked={false}
							value={product}
							color="primary"
							disabled={true}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>{productDesc}</Typography>}
					
					/></AlertTooltip></Grid>)
			}else{
				products.push(<Grid item  xs={12}><FormControlLabel
					control={
						<Checkbox
							defaultChecked={false}
							value={product}
							color="primary"
							onChange={this.handlecheckbox}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>{productDesc}</Typography>}
					
					/></Grid>)
			}
		});
		return (
			<Grid container item direction="column" alignItems="flex-start" justify="flex-start" spacing={0} xs={12}>
				<StepHeader index={this.props.stepIndex} title={this.props.stepTitle} active={true} first={false}/>
				{products}
			</Grid>
		);
	}
}

export default withTranslation()(TaskSelector);